module.exports = __webpack_public_path__ + "img/minus.a97e5dfb.svg";